import React from 'react'
// import Sidebar from '../Components/Sidebar'
import BookDetailR from '../Components/BookDetailR'
import HeaderTwo from './HeaderTwo'
import SidebarLayout from '../Components/sidebar/SidebarLayout'

const BookingD = () => {
  return (
    <>
      <SidebarLayout>

        <HeaderTwo />
        <div id="wrapper" className="col-md-12">
          <div style={{ position: "relative" }}>
            {/* <Sidebar /> */}
            <BookDetailR />
          </div>
        </div>
      </SidebarLayout>
    </>
  )
}

export default BookingD